import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { Reject } from '../Reject';
import { handleApiError } from '../handleApiError';

interface EmailState {
  isEmailAvailable?: boolean;
  checkingEmail: boolean;
  checkingEmailSuccess: boolean;
  checkingEmailError: boolean;
}

const initialState: EmailState = {
    isEmailAvailable: false,
    checkingEmail: false,
    checkingEmailSuccess: false,
    checkingEmailError: false,
};

interface EmailParams {
  email: string;
}

export const checkIfEmailExists = createAsyncThunk<boolean, EmailParams, Reject>(
    'checkIfEmailExists',
    async (params, thunkAPI) => {
        return axios
            .post<boolean>(
                `${process.env.REACT_APP_API_URL}/email`,
                {
                    email: params.email,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            .then((response) => response.data)
            .catch((error) => {
                const apiError = handleApiError(error);
                return thunkAPI.rejectWithValue(apiError);
            });
    }
);

const emailSlice = createSlice({
    name: 'email',
    initialState,
    reducers: {
        clearEmailState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(checkIfEmailExists.pending, (state) => {
                state.checkingEmail = true;
                state.isEmailAvailable = false;
                state.checkingEmailError = false;
                state.checkingEmailSuccess = false;
            })
            .addCase(checkIfEmailExists.rejected, (state) => {
                state.checkingEmail = false;
                state.checkingEmailError = true;
            })
            .addCase(checkIfEmailExists.fulfilled, (state, action) => {
                state.checkingEmail = false;
                state.checkingEmailSuccess = true;
                state.isEmailAvailable = !action.payload;
            });
    },
});

export const { clearEmailState } = emailSlice.actions;

export default emailSlice.reducer;
